import { render, staticRenderFns } from "./program-status-modal.vue?vue&type=template&id=22d4fc08"
import script from "./program-status-modal.vue?vue&type=script&lang=js"
export * from "./program-status-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports